module.exports = __webpack_public_path__ + "img/SKMJ_place3.5cb6121a.png";